import { render, staticRenderFns } from "./ViewOrdPickingDetail.vue?vue&type=template&id=6d28aa9a&scoped=true"
import script from "./ViewOrdPickingDetail.vue?vue&type=script&lang=js"
export * from "./ViewOrdPickingDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewOrdPickingDetail.vue?vue&type=style&index=0&id=6d28aa9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28aa9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d28aa9a')) {
      api.createRecord('6d28aa9a', component.options)
    } else {
      api.reload('6d28aa9a', component.options)
    }
    module.hot.accept("./ViewOrdPickingDetail.vue?vue&type=template&id=6d28aa9a&scoped=true", function () {
      api.rerender('6d28aa9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryOrder/ViewOrdPickingDetail.vue"
export default component.exports